import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import reportTypes from "./reportTypes";

import "../../styles/components/_table.scss";

export const CellLoader = () => (
  <motion.div
    className="table__item"
    animate={{ translateY: [1, 0, -1, 0] }}
    transition={{ duration: 1, loop: Infinity }}
  >
    <span
      className="greeked-text"
      style={{ width: `${Math.random() * 45 + 45}%` }}
    />
  </motion.div>
);

export const TableLoader = ({ columns, reportType }) => {
  const [mockColumns, setMockColumns] = useState([]);

  useEffect(() => {
    if (reportType === reportTypes.received) {
      let updatedColumns = [];
      for (let index = 0; index < columns.length; index += 1) {
        if (columns[index].columns && columns[index].columns.length > 0) {
          updatedColumns = updatedColumns.concat(columns[index].columns);
        } else {
          updatedColumns.push(columns[index]);
        }
      }
      setMockColumns(updatedColumns);
    } else {
      setMockColumns(columns);
    }
  }, [columns, reportType]);

  return Array.from({ length: 8 }, (x, i) => (
    <motion.div
      animate={{
        opacity: [0.5, 0.75, 1, 1, 1, 1, 0.5],
      }}
      transition={{ duration: 2, delay: i / 8, loop: Infinity }}
      className="table__row"
      key={i}
    >
      {mockColumns.map((column) => (
        <div
          className={`table__item table__item--${column.accessor}`}
          key={`${column.accessor}${i}`}
        >
          <span
            className="greeked-text"
            style={{ width: `${Math.random() * 45 + 45}%` }}
          />
        </div>
      ))}
    </motion.div>
  ));
};

TableLoader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object),
  reportType: PropTypes.oneOf([
    "Regular Support",
    "Financial Partner Changes",
    "Received Support",
  ]).isRequired,
};
